// src/AccountDeletion.js
import React from "react";
import { Container, Typography, Link } from "@mui/material";

function AccountDeletion() {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Hesap Silme
      </Typography>
      <Typography variant="body1" paragraph>
        Toruko olarak kullanıcılarımızın gizliliğine ve verilerinin kontrolüne büyük önem veriyoruz. 
        Hesabınızın kalıcı olarak silinmesini talep ediyorsanız, lütfen aşağıdaki e-posta adresine bir mesaj gönderin.
      </Typography>
      <Typography variant="body1">
        <Link href="mailto:support@korsananime.com">
          support@korsananime.com
        </Link>
      </Typography>
    </Container>
  );
}

export default AccountDeletion;
